import Heading, { HeadingProps } from './Heading';

export type H2Props = Omit<HeadingProps, 'as' | 'level'>;

/**
 * A section heading: an `<h2>` at visual level 2.
 *
 * ## When to use
 *
 * - A major section within a page, nested under the `H1`.
 *
 * ## When to choose another component
 *
 * - **The page's primary title** — use `H1`.
 * - **Smaller subsections** — use `H3` or `H4`.
 * - **Tag and visual level must differ** — use `Heading`, e.g.
 *   `<Heading as="h2" level={1}>`.
 * - **Body copy, captions, labels** — use `Text`.
 *
 * ## Composition rules
 *
 * Fixed to `as="h2" level={2}`. It exposes no `as`, `level`, `className` or
 * `style`, so its typography and semantics cannot be overridden.
 */
const H2 = (props: H2Props) => <Heading as="h2" level={2} {...props} />;

export default H2;
